import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
// tslint:disable-next-line:import-blacklist
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { Subject } from 'rxjs/Subject';
import { STATUS_DEFINITE, STATUS_PROPOSAL, STATUS_TENTATIVE } from '../util/constants';
import { DateUtil } from '../util/dateUtil';
import { LogService } from './shared/log.service';
import { NGaugeService } from './shared/ngauge.service';
import { UserService } from './user.service';
import { AuthService } from './shared/auth.service';

interface BroadcastEvent {
  key: any;
  data?: any;
}
@Injectable()
export class FunctionService {

  scheduleDetails: any;
  roomType: any;
  beoDetails: any;
  roomSchedule = new Subject();
  duplicate = new Subject();
  duplicateData = new Subject();
  listOfEvents: any;
  currentPage: any;
  scheduleRoomAction: any;
  roomScheduleValues: any;
  randomRoomScheduleId: any;
  _eventBus: Subject<BroadcastEvent>;
  menuSub = new BehaviorSubject<any>(null);
  menu$ = this.menuSub.asObservable();

  constructor(
    public httpClient: HttpClient,
    public userService: UserService,
    public logService: LogService,
    public ngaugeService: NGaugeService,
    private authService: AuthService) {
    this._eventBus = new Subject<BroadcastEvent>();
  }

  broadcast(key: any, data?: any) {
    this._eventBus.next({ key, data });
  }

  on<T>(key: any): Observable<T> {
    return this._eventBus.asObservable()
      .filter(event => event.key === key)
      .map(event => <T>event.data);
  }

  createFunction(functionDetails) {
    return this.httpClient.post(this.ngaugeService.getMeldURL('CREATEFUNCTION'), { 'functiondetail': functionDetails , 'SID':this.authService.getSID() });
  }

  updateFunction(functionDetail) {
    return this.httpClient.put(this.ngaugeService.getMeldURL('UPDATEFUNCTION'), { 'functiondetail': functionDetail, 'SID':this.authService.getSID() });
  }

  setBeo(beoDetail) {
    this.beoDetails = beoDetail;
  }

  getBeo() {
    return this.beoDetails;
  }

  createNotes(functionNotes) {
    return this.httpClient.post(this.ngaugeService.getMeldURL('FUNCTIONNOTES'), { 'notesdetail': functionNotes });
  }

  updateNotes(functionNotes) {
    return this.httpClient.put(this.ngaugeService.getMeldURL('UPDATEFUNCTIONNOTES'), { 'notesdetail': functionNotes });
  }


  updateFunctionsalesActivity(salesActivityDetails) {
    return this.httpClient.put(this.ngaugeService.getMeldURL('UPDATEFUNCTIONSALESACTIVITY'),
      { 'salesactivitydetail': salesActivityDetails , 'SID' : this.authService.getSID() });
  }

  updateFunctionActivity(values) {
    return this.httpClient.put(this.ngaugeService.getMeldURL('GET_FUNCTION') + '/' + values.functionId, values);
  }

  createFunctionsalesActivity(salesActivityDetails) {
    return this.httpClient.post(this.ngaugeService.getMeldURL('CREATEFUNCTIONSALESACTIVITY'),
      { 'salesactivitydetail': salesActivityDetails , 'SID' : this.authService.getSID() });
  }

  setFunctionRoom(roomSchedule: any) {
    this.roomSchedule.next(roomSchedule);
  }

  getFunctionRoom() {
    return this.roomSchedule.asObservable();
  }

  setDuplicate(duplicate: any) {
    this.duplicate.next(duplicate);
  }

  getDuplicate() {
    return this.duplicate.asObservable();
  }

  setTableData(duplicateData: any) {
    this.duplicateData.next(duplicateData);
  }

  getTableData() {
    return this.duplicateData.asObservable();
  }

  createBeo(beoDetail) {
    return this.httpClient.post(this.ngaugeService.getMeldURL('ADDBEO'), { beoFunctionDetail: beoDetail, SID: this.authService.getSID() });
  }

  updateBeo(updateBeoDetail) {
    return this.httpClient.put(this.ngaugeService.getMeldURL('UPDATEBEO'), { beoFunctionDetail: updateBeoDetail, SID: this.authService.getSID() });
  }

  getFunctionBeo(functionId) {
    let params = new HttpParams();
    params = params.append('functionId', functionId).append('SID',this.authService.getSID());
    return this.httpClient.get(this.ngaugeService.getMeldURL('GETBEO'), { params: params });
  }

  setScheduleRoom(detail) {
    this.scheduleDetails = detail;
  }

  getScheduleRoom() {
    return this.scheduleDetails;
  }

  setRoomtype(value, startTime, endTime, squareFeet, weekDayRent, reqSqFeet, capacity) {
    this.roomType = {
      'roomType': value, 'startTimes': startTime, 'endTimes': endTime, 'squareFeet': squareFeet,
      'weekDayRent': weekDayRent, reqSqFeet, capacity
    };
  }

  getRoomtype() {
    return this.roomType;
  }

  setListOfEvents(value) {
    this.listOfEvents = value;
  }

  getListOfEvents() {
    return this.listOfEvents;
  }

  setScheduleRoomAction(value) {
    this.scheduleRoomAction = value;
  }

  getScheduleRoomAction() {
    return this.scheduleRoomAction;
  }


  setRoomSchedule(value) {
    this.roomScheduleValues = value;
  }

  getRoomSchedule() {
    return this.roomScheduleValues;
  }

  getFunctionDetails(functionlist, eventslist, accountNameValue: boolean): any {
    return new Promise(resolve => {
      const book = [];
      for (let i = 0; i < functionlist.length; i++) {
        functionlist[i].roomSchedule = this.ngaugeService.isJSON(functionlist[i].roomSchedule);
        if (functionlist[i].roomSchedule.length > 0) {
          for (let j = 0; j < functionlist[i]['roomSchedule'].length; j++) {
            const calendarDataList = functionlist[i].roomSchedule[j];
            if (calendarDataList.startTime) {
              const eventFound = eventslist.find(event => event['title'] === calendarDataList['room']);
              if (eventFound) {
                calendarDataList.startDate = DateUtil.getValidTimeZoneT(calendarDataList.startDate);
                calendarDataList.endDate = DateUtil.getValidTimeZoneT(calendarDataList.endDate);
                const eventColour = calendarDataList.status === STATUS_PROPOSAL ? '#FF5454' :
                  calendarDataList.status === STATUS_TENTATIVE ? '#F4B400' :
                    calendarDataList.status === STATUS_DEFINITE ? '#3DCC5B' :
                      calendarDataList.status === 'Non-Movable' ? '#3a3a3a' : '#ccc';
                if (calendarDataList.roomScheduleId === null ||
                  calendarDataList.roomScheduleId === undefined) {
                  calendarDataList.roomScheduleId = 1;
                }
                console.log('Function Room found');
                const resourceId = eventslist.filter(resource => resource['name'] === calendarDataList['room'])[0]['id'];
                const tempdata = {
                  'id': calendarDataList['roomScheduleId'],
                  'title': calendarDataList['eventType'],
                  'accountName': accountNameValue ? functionlist[i]['account']['account'] : functionlist[i]['accountName'],
                  'functionName': functionlist[i]['functionName'],
                  'start': DateUtil.getFormattedDate(DateUtil.getNewDate(calendarDataList['startDate'])) + 'T' +
                    calendarDataList.startTime,
                  'end': DateUtil.getFormattedDate(DateUtil.getNewDate(calendarDataList['endDate'])) + 'T' +
                    calendarDataList.endTime,
                  'color': eventColour,
                  'status': calendarDataList['status'],
                  'roomType': calendarDataList['room'],
                  'noOfPeople': calendarDataList['noOfPeople'],
                  'resourceIds': '[\'' + resourceId + '\']'
                };
                book.push(tempdata);
              }
            }
          }
        }
      }
      resolve(book);
    });
  }

  setRoomScheduleId(value) {
    this.randomRoomScheduleId = value;
  }

  updateFunctionsalesDate(id, data) {
    return this.httpClient.put(this.ngaugeService.getMeldURL('UPDATEFUNCTIONDATE') + '/' + id, data);
  }

  getEventTimes(eventstarti, eventendi) {
    if (eventstarti[4].toLocaleString().length < 2) {
      eventstarti[4] = 0 + '' + eventstarti[4];
    }
    if (eventendi[4].toLocaleString().length < 2) {
      eventendi[4] = 0 + '' + eventendi[4];
    }
    let startTime = eventstarti[3] + ':' + eventstarti[4];
    let endTime = eventendi[3] + ':' + eventendi[4];
    const timeStart = startTime.toLocaleString().split(':');
    const timeEnd = endTime.toLocaleString().split(':');
    startTime = timeStart[0] + ':' + timeStart[1];
    endTime = timeEnd[0] + ':' + timeEnd[1];
    return { startTime, endTime };
  }

  getEventDates(eventstarti, eventendi) {
    if (eventstarti[1].toLocaleString().length < 2) {
      eventstarti[1] = 0 + '' + (Number(eventstarti[1]) + 1);
    }
    if (eventstarti[2].toLocaleString().length < 2) {
      eventstarti[2] = 0 + '' + eventstarti[2];
    }
    if (eventendi[1].toLocaleString().length < 2) {
      eventendi[1] = 0 + '' + (Number(eventendi[1]) + 1);
    }
    if (eventendi[2].toLocaleString().length < 2) {
      eventendi[2] = 0 + '' + eventendi[2];
    }
    return {
      'startDate': eventstarti[0] + '-' + eventstarti[1] + '-' + eventstarti[2], 'endDate': eventendi[0] + '-' +
        eventendi[1] + '-' + eventendi[2]
    };
  }

  getRoomScheduleId() {
    return this.randomRoomScheduleId;
  }

  getfunctionById(functionId) {
    const whereCondition = '"where": {"id":' + functionId + '}';
    const filter = '{' + whereCondition + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_FUNCTION'), params);
  }

  getFuncSalesActivitiesById(functionId, accountId) {
    const whereFilter = '"where": {"and": [{"functionId":' + functionId + '},{"accountId": ' + accountId + '}]}';
    const filter = '{' + whereFilter + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_FUNCTION_SALES_ACTIVITY'), params);
  }

  getFunctionNotes(functionId) {
    const whereCondition = '"where": { "functionId":' + functionId + '}';
    const filter = '{' + whereCondition + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_FUNCTION_NOTES'), params);
  }
  getFuncSalesActivities() {
    const columnFilter = '"fields":["id", "functionName", "status", "typeOfTrace", "contact", "cancellationReason", "finalStatus","SID"]';
    const filter = '{' + columnFilter + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_FUNCTION'), params);
  }

  getAllfunctionSalesActivity(functionId) {
    const whereFilter = '"where": {"functionId":' + functionId + '}';
    const filter = '{' + whereFilter + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_FUNCTION_SALES_ACTIVITY'), params);
  }

  getDiffBetwnTwoDays(fromDate, toDate, value) {
    return { 'diffValue': Math.round((fromDate - toDate) / (1000 * 60 * 60 * 24)), 'sumValue': value };
  }

  getMenuCategoryAndCode() {
    const whereCondition = '"where": {"property" :"' + this.userService.getLoggedInUserProperty() + '"}';
    const filter = '{' + whereCondition + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_MENU_CODES'), params);
  }

  publishMenuDataEdit(id) {
    this.menuSub.next(id);
  }

  getMenuCategory() {
    const filter = this.getNameAndIdFilter();
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_MENU_CATEGORIES'), params);
  }

  getMenuCode() {
    const columnFilter = '"fields": ["categoryName", "chargeToCategory", "id","SID"]';
    const filter = '{' + columnFilter + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_MENU_CODES'));
  }

  getMeasures() {

    const filter = this.getNameAndIdFilter();
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_MEASURES'), params);
  }

  getMenuById(id) {
    const whereCondition = '"where": {"id":' + id + '}';
    const filter = '{' + whereCondition + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_MENU_CODES'), params);
  }

  addMenuCategory(menu) {
    const data = {
      createdBy: this.userService.getLoggedInUserName(),
      createdOn: new Date(),
      name: menu,
      status: 'Active',
      id: 0
    };
    return this.httpClient.post(this.ngaugeService.getMeldURL('GET_MENU_CATEGORIES'), data);
  }

  addMeasures(measure) {
    const data = {
      createdBy: this.userService.getLoggedInUserName(),
      createdOn: new Date(),
      name: measure,
      status: 'Active',
      id: 0
    };
    return this.httpClient.post(this.ngaugeService.getMeldURL('GET_MEASURES'), data);
  }

  removeMenuCategory(id) {
    return this.httpClient.delete(this.ngaugeService.getMeldURL('GET_MENU_CATEGORIES') + '/' + id);
  }

  saveMenu(values) {
    values['SID'] = this.userService.getSID();
    if (values['id'] === undefined) {
      return this.httpClient.post(this.ngaugeService.getMeldURL('GET_MENU_CODES'), values);
    } else {
      return this.httpClient.put(this.ngaugeService.getMeldURL('GET_MENU_CODES'), values);
    }
  }

  deleteMenuCode(id) {
    return this.httpClient.delete(this.ngaugeService.getMeldURL('GET_MENU_CODES') + '/' + id);
  }

  // get dropdown based on MenuItem list
  getMenuCodesItemList(menu) {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('categoryname', menu);
    return this.httpClient.get(this.ngaugeService.getMeldURL('GETMENUCODESLIST'), { params: httpParams });
  }

  getRevenueCenter() {
    const columnFilter = '"fields": ["name", "id", "order", "categories","SID"]';
    const filter = '{"where": {"SID":'+this.authService.getSID()+'},' + columnFilter + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_REVENUE_CENTERS'), params);
  }

  // get dropdown of RoomSetup list
  getRoomSetupList() {
    const whereFilter = '"where": {"property": "' + this.userService.getLoggedInUserProperty() + '"}';
    const columnFilter = '"fields": ["name", "id", "capacity", "perPersonArea","SID"]';
    const filter = '{' + columnFilter + ',' + whereFilter + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GETROOMSETUPLIST'), params);
  }

  getFunctionRoomsTypes(userProperty) {
    if (this.ngaugeService.functionRooms !== null && this.ngaugeService.functionRooms.length > 0
      && !this.ngaugeService.getIsClusterProperty()) {
      return of(this.ngaugeService.functionRooms);
    } else {
      const whereFilter = '"where": {"or":[{"property": "' + userProperty + '"},'+'{"SID":"'+this.authService.getSID()+'"}]}';
      const filter = '{' + whereFilter + '}';
      const params = { params: this.ngaugeService.getHttpParams(filter) };
      return this.httpClient.get(this.ngaugeService.getMeldURL('GETFUNCTIONROOMSLIST'), params).map((res: any) => {
        this.ngaugeService.functionRooms = res;
        return this.ngaugeService.functionRooms;
      });
    }
  }

  getCompPoliciesTypes() {
    const whereFilter = '"where": {"property": "' + this.userService.getLoggedInUserProperty() + '"}';
    const columnFilter = '"fields": ["name", "id","SID"]';
    const filter = '{' + whereFilter + ',' + columnFilter + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_GROUP_COMPPOLICY'), params);
  }

  getFunctionParkingList() {
    const filter = this.getNameAndIdFilter();
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_ACCOUNT_GROUP_PARKING_LIST'), params);
  }

  getFunctionEventTypes() {
    const filter = this.getNameAndIdFilter();
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GETFUNCTIONEVENTSLIST'), params);
  }

  getPaymentsTypes() {
    const filter = this.getNameAndIdFilter();
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GETFUNCTIONPAYMENTLIST'), params);
  }

   getNameAndIdFilter() {
    const columnFilter = '"fields": ["name", "id","SID"]';
    return '{"where": {"SID":'+this.authService.getSID()+'},' + columnFilter + '}';
  }

  getMenuItemList() {
    const filter = this.getNameAndIdFilter();
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GETMENUITEMLIST'), params);
  }

  getMasterDropDowns(propertyName) {
    let httpParams = new HttpParams();
    let sid= JSON.parse(sessionStorage.getItem('sid'))
    httpParams = httpParams.append('property', propertyName);
    httpParams=httpParams.append('SID',sid)
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_FUNCTION_MASTERT_TABLES'), { params: httpParams });
  }

  getCuttOffDates() {
    const filter = '{"fields": ["type", "id", "duration", "name", "description"]}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_FUNCTION_CUT_OFF_DATES'), params);
  }

  getContractTemplate() {
    const whereCondition = '"where": {"type":"Function_Agreement"}';
    const filter = '{' + whereCondition + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_CONTRACT_TEMPLATES'), params);
  }

  getFloorDesign(room, setup) {
    const whereCondition = '"where": {"and": [{"roomname": "' + room + '"}, {"setup": "' + setup + '"}]}';
    const filter = '{' + whereCondition + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('FUNCTION_ROOM_DESIGNS'), params);
  }

  getRoomDesigns() {
    const whereCondition = '"where": {"type": "room-design"}';
    const fields = '"fields": ["design", "dimension", "id","property","roomname","type"]';
    const filter = '{' + whereCondition + ',' + fields + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('FUNCTION_ROOM_DESIGNS'), params);
  }

  saveDesign(param) {
    if (param.id === undefined) {
      return this.httpClient.post(this.ngaugeService.getMeldURL('FUNCTION_ROOM_DESIGNS'), param);
    } else {
      return this.httpClient.put(this.ngaugeService.getMeldURL('FUNCTION_ROOM_DESIGNS') + '/' + param.id, param);
    }
  }

  deleteRoomDesign(roomScheduleId) {
    return this.httpClient.post(this.ngaugeService.getMeldURL('DELETE_ROOM_DESIGN'), {roomScheduleId});
  }

  deleteRoomDesignById(roomId: number) {
    return this.httpClient.delete(this.ngaugeService.getMeldURL('FUNCTION_ROOM_DESIGNS') + '/' + roomId);
  }

  getRoomDiagram(functionId, roomScheduleId) {
    const whereCondition = '"where": {"and": [{"accountFunctionId": "' + functionId + '"},{"roomScheduleId": "' + roomScheduleId + '"}]}';
    const filter = '{' + whereCondition + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('FUNCTION_ROOM_DESIGNS'), params);
  }

  getalcoholTax(property) {
    const whereCondition = '"where": {"property": "'+property+'"}';
    const filter = '{' + whereCondition + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_ALCOHOL_TAX'),params);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/function.service.ts